import { actions as messagesActions } from "../actions/messages";
import { messages } from "../constants/actionTypes";

// The server-confirmed inbox actions that change what the sidebar badge should say. messages.js dispatches each one
// only after its POST succeeded, so a failed request never reaches here (GROWTH-7192).
const COUNT_CHANGING_TYPES = new Set([
  messages.READ_MESSAGE,
  messages.UNREAD_MESSAGE,
  messages.ARCHIVE_MESSAGE,
  messages.UN_ARCHIVE_MESSAGE
]);

/**
 * After an inbox action succeeds, asks the server for the member's counts so the sidebar Inbox badge (and the banner
 * logic that reads `unread_messages`) follow it without a reload. It sits in the store, not in the four action
 * thunks, so the thunks keep sending exactly the requests they always did.
 */
export const inboxCountsMiddleware = store => next => action => {
  const result = next(action);

  if (COUNT_CHANGING_TYPES.has(action?.type)) {
    store.dispatch(messagesActions.getInboxCounts());
  }

  return result;
};
